/* Copyright (c) 2019-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { GfcEventsServerConfig } from '../config/gfc-events.config';

export const GfcEventsDefaultServerConfig: GfcEventsServerConfig = {
    server: 'https://telemetry.gfe.nvidia.com',
    version: 'v1.0',
    schemaVersion: '',
    msBetweenChunkCreation: 300000,
    maxBufferSizeInBytes: 25600,
    chunksQueueSize: 20,
    chunkResendRetryLimit: 2,
    clientId: '',
    retryConfig: {
        defaultRetries: 2,
        defaultTimeout: 30000,
        defaultTimeBetweenRetries: 1000
    }
};

export const FeedbackProtocolVersion = '4.4';

// Should match the enum value in the json schema
export const GfcOriginalServiceName = 'Gfc';

// Should match the enum values in the json schema
export enum GfcServiceUseCase {
    GfcHeadRequest = 'FeedbackHead',
    GfcAttachmentRequest = 'FeedbackAttachment'
}
